import React from 'react';
import { observer } from 'mobx-react-lite';

import { Jets } from '../jets';
import { BetSection } from '../betSection';

export const GameMain = observer(
  ({
    extraProps,
    handleChangeAutoBet,
    changeBetInputValue,
    handleSwitchAutoCashOut,
    handleChangeAutoCashOutInputValue,
  }) => {
    return (
      <div className='fighters-game-wrapper'>
        <div className='fighters-logo-block' />
        <Jets />
        <BetSection
          extraProps={extraProps}
          handleChangeAutoBet={handleChangeAutoBet}
          changeBetInputValue={changeBetInputValue}
          handleSwitchAutoCashOut={handleSwitchAutoCashOut}
          handleChangeAutoCashOutInputValue={handleChangeAutoCashOutInputValue}
        />
      </div>
    );
  }
);
